// extracted by mini-css-extract-plugin
export default {"inputBox":"timePicker_inputBox__65Ff4"};